import React from 'react'; // eslint-disable-line
import { Link } from 'react-router-dom';

const Catch404 = () => {
    return (
        <div className="catch404">
            <svg
                width="122px"
                height="128px"
                viewBox="0 0 122 128"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs>
                    <filter
                        x="0.0%"
                        y="0.0%"
                        width="100.0%"
                        height="100.0%"
                        filterUnits="objectBoundingBox"
                        id="filter-1"
                    >
                        <feGaussianBlur stdDeviation="0" in="SourceGraphic" />
                    </filter>
                </defs>
                <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g
                        id="search-text-based-error-not-found"
                        transform="translate(-128.000000, -190.000000)"
                    >
                        <g id="sad-search" transform="translate(128.000000, 191.000000)">
                            <g id="Group-2" transform="translate(14.000000, 0.000000)">
                                <path
                                    d="M73.2,71.5664071 L95.9515025,91.1662422"
                                    id="Oval-5"
                                    stroke="#343434"
                                    strokeWidth="2"
                                    fill="#FFFFFF"
                                />
                                <ellipse
                                    id="Oval-5"
                                    stroke="#343434"
                                    strokeWidth="2"
                                    cx="42.6"
                                    cy="42.6992849"
                                    rx="42.6"
                                    ry="42.6992849"
                                />
                                <g id="Group-3" transform="translate(19.000000, 38.000000)">
                                    <g
                                        id="Group-5"
                                        transform="translate(2.000000, 0.000000)"
                                        fill="#343434"
                                    >
                                        <circle
                                            id="Oval-6"
                                            cx="4.49090909"
                                            cy="4.27042746"
                                            r="4"
                                        />
                                        <circle
                                            id="Oval-6"
                                            cx="40.4909091"
                                            cy="4.27042746"
                                            r="4"
                                        />
                                    </g>
                                    <path
                                        d="M33,25 C30.7101177,22.5314357 27.5199181,21 23.5263158,21 C20.4717548,21 17.2886508,22.523827 15,25"
                                        id="Oval-7"
                                        stroke="#343434"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M5,25 C7.76142375,25 10,22.8121085 10,20 C10,18.2762044 8.33333333,15.2762044 5,11 C1.66666667,15.2762044 0,18.2762044 0,20 C0,22.8121085 2.23857625,25 5,25 Z"
                                        id="Tear"
                                        fill="#00E5FF"
                                    />
                                </g>
                            </g>
                            <ellipse
                                id="Oval-8"
                                fill="#E6EBF2"
                                filter="url(#filter-1)"
                                cx="59"
                                cy="124"
                                rx="40"
                                ry="3"
                            />
                            <circle
                                id="Oval-3"
                                fill="#C7DBFF"
                                opacity="0.300000012"
                                cx="116"
                                cy="21"
                                r="6"
                            />
                            <circle
                                id="Oval-3"
                                fill="#C7DBFF"
                                opacity="0.300000012"
                                cx="6"
                                cy="82"
                                r="6"
                            />
                        </g>
                    </g>
                </g>
            </svg>
            <h3>
                Oops! This page doesn&apos;t seem to exist,
                &nbsp;and we don&apos;t know how you arrived here!
                <br />
                Please try starting from the
                <Link to="/">Projects Page</Link>
            </h3>
        </div>
    );
};

export default Catch404;
